<template>
  <div class="entry-list">
    <entry-projects-group
      heading="Active Projects"
      :projects="activeProjects"
      :currentProject="currentProject"
    />
    <entry-projects-group
      heading="Archived"
      :projects="inactiveProjects"
      :currentProject="currentProject"
      :is-archive="true"
    />
  </div>
</template>

<script>
import EntryProjectsGroup from './entry-projects-group.vue'

export default {
  components: { EntryProjectsGroup },
  name: 'entry-list',
  computed: {
    activeProjects() {
      return this.$store.getters.activeProjects
    },
    inactiveProjects() {
      return this.$store.getters.inactiveProjects
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    }
  }
}
</script>

<style lang="scss">
.entry-list {
  position: relative;
  z-index: 2;
  height: 100%;
  padding-right: 2px;
  overflow: auto;
  color: #fff;
  background-color: $gray-900;
  border-right: 2px solid $gray-900;
  overflow-anchor: none;
  &::-webkit-scrollbar {
    width: 4px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba($white, 0.5);
  }
}
</style>
